















import { Component, Mixins, Watch, Vue, Prop, Model, Emit } from 'vue-property-decorator'
import ExternDataProductApi from '@/api/externData/product/index'

@Component
export default class SyncProductModal extends Vue {
  @Prop()
  @Model('change', { type: Boolean })
  modal!: boolean

  formData = { itemCode: '' }
  ruleValidate = {
    itemCode: [{ required: true, message: '商品款号不能为空', trigger: 'blur' }],
  }
  loading = false
  ok() {
    ;(this.$refs['formValidate'] as any).validate((valid) => {
      if (valid) {
        this.loading = true
        ExternDataProductApi.newSyncProduct(this.formData.itemCode)
          .then((res) => {
            this.$Message.success('同步成功')
            this.loading = false
            this.$emit('change', false)
            this.$emit('on-change')
          })
          .catch((err) => {
            this.$Message.error('同步失败')
            this.loading = false
          })
      }
    })
  }
  cancel() {
    this.$emit('change', false)
    this.$emit('on-change')
  }
  // onVisibleChange(value: boolean) {
  //   if (!value) {
  //     this.$emit('change', false)
  //   }
  // }
}
